import { Button, InlineStack, Tooltip } from '@shopify/polaris';
import { DesktopIcon, MaximizeIcon, MinimizeIcon, MobileIcon } from '@shopify/polaris-icons';

export default function PreviewToolbar({ mobile, expanded, onDevice, onExpand }: {
    mobile: boolean; expanded: boolean; onDevice: (mobile: boolean) => void; onExpand: () => void;
}) {
    const expandLabel = expanded ? 'Close preview' : 'Expand preview';
    return <InlineStack gap="200">
        <Tooltip content="Desktop"><Button icon={DesktopIcon} accessibilityLabel="Desktop" pressed={!mobile} onClick={() => onDevice(false)} /></Tooltip>
        <Tooltip content="Mobile"><Button icon={MobileIcon} accessibilityLabel="Mobile" pressed={mobile} onClick={() => onDevice(true)} /></Tooltip>
        <Tooltip content={expandLabel}><Button icon={expanded ? MinimizeIcon : MaximizeIcon} accessibilityLabel={expandLabel} onClick={onExpand} /></Tooltip>
    </InlineStack>;
}
